module.exports = __webpack_public_path__ + "static/media/campusImgA.0ee2e649.png";